import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { SmParams, BaseEventData, CONSTANTS, TrackEventData, LogEventData } from './types';

/**
 * Get common event data for tracking
 * @param smParams
 * @returns
 */
function getCommonEventData(smParams?: SmParams): Partial<BaseEventData> {
  return {
    surveyId: smParams?.surveyId,
    collectorId: smParams?.collectorId,
    respondentId: smParams?.respondentId,
    surveyCategoryId: smParams?.categoryId ?? 'None',
    languageId: smParams?.languageId,
    app: CONSTANTS.APP,
    urlPath: typeof window !== 'undefined' ? window.location.pathname : '',
  };
}

/**
 * Send metrics for end page events
 * @param eventData
 */
function trackEvent({ eventName, amplitudeEvent, pageName, templateType, smParams }: TrackEventData): void {
  const commonData = getCommonEventData(smParams);
  const finalEventData = {
    name: eventName,
    data: {
      ...commonData,
      templateType,
      amplitudeEvent,
      pageName,
      log: {
        message: templateType ?? null,
      },
    },
  };
  MetricsTracker.track(finalEventData);
}

/**
 * Send log data for end page events
 * @param message
 * @param countryCode
 * @param countryRegion
 * @param languageId
 */
function sendLog({ message, countryCode, countryRegion, languageId }: LogEventData): void {
  MetricsTracker.track({
    name: USER_EVENTS.PAGE_VIEW,
    data: { log: { message, countryCode, countryRegion, languageId } },
  });
}

export { trackEvent, sendLog };
export type { SmParams };
